import { render, staticRenderFns } from "./channelChangeRecord.vue?vue&type=template&id=3ef463ff&scoped=true"
import script from "./channelChangeRecord.vue?vue&type=script&lang=js"
export * from "./channelChangeRecord.vue?vue&type=script&lang=js"
import style0 from "./channelChangeRecord.vue?vue&type=style&index=0&id=3ef463ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef463ff",
  null
  
)

export default component.exports